import { render, staticRenderFns } from "./ResolveConflictOption.vue?vue&type=template&id=deda5ec8&scoped=true&"
import script from "./ResolveConflictOption.vue?vue&type=script&lang=js&"
export * from "./ResolveConflictOption.vue?vue&type=script&lang=js&"
import style0 from "./ResolveConflictOption.vue?vue&type=style&index=0&id=deda5ec8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deda5ec8",
  null
  
)

export default component.exports